import React from "react";

type IconProps = {
  size?: number | string;
  color?: string;
};

export const SkipBackward15MobileIcon = ({
  size,
  color,
}: IconProps): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || "31"}
      height={size || "30"}
      viewBox="0 0 31 30"
      fill="none"
      style={{
        shapeRendering: "geometricPrecision",
        imageRendering: "-webkit-optimize-contrast",
      }}
    >
      <path
        d="M20.2321 28.3378C23.2177 27.2016 25.7251 25.0786 27.3381 22.3212C28.951 19.5638 29.5726 16.3377 29.0995 13.1784C28.6265 10.019 27.0874 7.11646 24.7375 4.95235C22.3877 2.78824 19.3685 1.49274 16.181 1.28085C12.9935 1.06896 9.82935 1.95342 7.21374 3.78744C4.59813 5.62147 2.68831 8.29478 1.80126 11.3637"
        stroke={color || "white"}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.25139 1.25V11.433L11.3555 10.1779"
        stroke={color || "white"}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SkipBackward15MobileIcon;
